<script setup>
  import { DateTime } from 'luxon'
  import { computed } from 'vue'
  import { NFlex } from 'naive-ui'
  import NetworkConnectionStatus from '@/components/utilities/network-connection-status.vue'
  import RtlsConnectionStatus from '@/components/utilities/rtls-connection-status.vue'
  import ToggleFullScreen from '@/components/utilities/toggle-full-screen.vue'

  const copyright = computed(() => {
    const year = DateTime.now().toFormat('yyyy')
    return `\u00A9 ${year} American RFID Solutions, LLC.  All rights reserved.`
  })
</script>
<template>
  <NFlex justify="center">
    <span>
      <ToggleFullScreen />
    </span>
    <span class="grow text-center">{{ copyright }}</span>
    <span>
      <RtlsConnectionStatus />
      <NetworkConnectionStatus />
    </span>
  </NFlex>
</template>
<style scoped>
  .n-flex {
    @apply text-sm;

    span {
      min-width: 20%;
    }

    span:first-child,
    span:last-child {
      display: flex;

      > * {
        margin-right: 0.25rem;
        padding-right: 0.25rem;
      }
    }

    span:first-child {
      justify-content: flex-start;
      padding-left: 0.5rem;
    }

    span:last-child {
      justify-content: flex-end;
      padding-right: 0.5rem;
    }
  }
</style>
